import Breadcrumb from "@/components/feature/Breadcrumb";
import { siteInfo, brandInfo } from "@/mocks/data";

export default function AboutPage() {
  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: `关于我们 - ${siteInfo.name}`,
    description: brandInfo.intro,
    url: "https://www.damanguan-official.com/about",
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteInfo.name,
    url: "https://www.damanguan-official.com",
    description: brandInfo.intro,
    contactPoint: {
      "@type": "ContactPoint",
      telephone: siteInfo.contact.phone,
      contactType: "customer service",
      availableLanguage: "Chinese",
      hoursAvailable: siteInfo.contact.workingHours,
    },
    address: {
      "@type": "PostalAddress",
      addressLocality: "上海",
      addressRegion: "上海",
      addressCountry: "CN",
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <main className="min-h-screen bg-background-50">
        <div className="pt-20">
          <Breadcrumb
            items={[
              { label: "首页", href: "/" },
              { label: "关于我们" },
            ]}
          />
        </div>

        <section className="py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h1
              className="text-3xl md:text-4xl font-bold text-foreground-950 mb-6 text-center"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              关于大满贯
            </h1>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed text-center max-w-3xl mx-auto mb-16">
              {brandInfo.intro}
            </p>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4 text-center" style={{ fontFamily: "var(--font-heading)" }}>
                我们的使命
              </h2>
              <p className="text-foreground-500 text-center text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
                {brandInfo.mission}
              </p>
            </div>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center" style={{ fontFamily: "var(--font-heading)" }}>
                核心价值
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {brandInfo.values.map((v, i) => (
                  <div
                    key={i}
                    className="bg-background-100 rounded-2xl p-6 text-center border border-background-200"
                  >
                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-accent-100 rounded-xl">
                      <i className="ri-star-line text-accent-600 text-xl"></i>
                    </div>
                    <h3 className="text-base font-bold text-foreground-950 mb-2">{v.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{v.description}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center" style={{ fontFamily: "var(--font-heading)" }}>
                品牌信誉
              </h2>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
                {brandInfo.reputation.map((r, i) => (
                  <div
                    key={i}
                    className="bg-background-100 rounded-2xl p-6 text-center border border-background-200"
                  >
                    <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center">
                      <i className={`${r.icon} text-accent-600 text-xl`}></i>
                    </div>
                    <div className="text-2xl md:text-3xl font-bold text-accent-600 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                      {r.value}
                    </div>
                    <div className="text-xs text-foreground-500">{r.label}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center" style={{ fontFamily: "var(--font-heading)" }}>
                发展历程
              </h2>
              <div className="relative max-w-2xl mx-auto">
                <div className="absolute left-[19px] top-0 bottom-0 w-0.5 bg-background-200"></div>
                <div className="flex flex-col gap-6">
                  {brandInfo.milestones.map((m, i) => (
                    <div key={i} className="flex items-start gap-5 relative">
                      <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-full flex-shrink-0 z-10">
                        <span className="text-white text-xs font-bold">{m.year.slice(2)}</span>
                      </div>
                      <div className="bg-background-100 rounded-xl p-4 border border-background-200 flex-1">
                        <span className="text-xs text-primary-500 font-bold block mb-1">{m.year}</span>
                        <span className="text-sm text-foreground-700">{m.event}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center" style={{ fontFamily: "var(--font-heading)" }}>
              联系我们
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {[
                { icon: "ri-phone-line", label: "客服热线", value: siteInfo.contact.phone },
                { icon: "ri-mail-line", label: "电子邮箱", value: siteInfo.contact.email },
                { icon: "ri-wechat-line", label: "微信公众号", value: siteInfo.contact.wechat },
                { icon: "ri-qq-line", label: "官方QQ群", value: siteInfo.contact.qq },
              ].map((item, i) => (
                <div
                  key={i}
                  className="bg-background-50 rounded-2xl p-5 text-center border border-background-200"
                >
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center bg-primary-100 rounded-xl">
                    <i className={`${item.icon} text-primary-500 text-lg`}></i>
                  </div>
                  <h4 className="text-xs font-semibold text-foreground-500 mb-2">{item.label}</h4>
                  <p className="text-sm font-bold text-foreground-950">{item.value}</p>
                </div>
              ))}
            </div>
            <div className="mt-8 bg-background-50 rounded-2xl p-6 border border-background-200 text-center">
              <div className="flex items-center justify-center gap-2 mb-2">
                <i className="ri-time-line text-primary-500"></i>
                <span className="text-xs font-semibold text-foreground-500">工作时间</span>
              </div>
              <p className="text-sm font-bold text-foreground-950">{siteInfo.contact.workingHours}</p>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}